<template>
    <div>
        <!-- Map Element -->
        <div style="position: relative">
            <l-map
                style="height: 100vh"
                :zoom="zoom"
                :center="center"
                ref="myMap"
                :options="{
                    zoomControl: false,
                    gestureHandling: gestureHandling,
                    maxZoom: 18,
                    attributionControl: false
                }"
                gestureHandling
                @update:zoom="zoomUpdated"
            >
                <l-control
                    v-show="showMenu"
                    position="topright"
                    class="leaflet-control"
                    v-click-outside="haveClickOutSide"
                >
                    <div class="geojson-type">
                        <div
                            v-if="
                                listLayers.findIndex((item) => item.name == 'Mưa thực đo') > -1 &&
                                realRainLayer.enabled
                            "
                        >
                            <button
                                class="
                                    btn btn-link
                                    bg-transparent
                                    border-none
                                    text-left
                                    shadow-none
                                    text-decoration-none
                                    dropdown-toggle-no-caret
                                "
                                @click="setRealRainMeasured"
                            >
                                <i
                                    :class="`fa fa-${realRainLayer.symbol.icon} fa-lg mr-1 ${realRainLayer.symbol.color}`"
                                ></i
                                ><span class="text-dark font-weight-bold">{{
                                    realRainLayer.name
                                }}</span>
                            </button>
                        </div>

                        <div
                            v-if="
                                listLayers.findIndex((item) => item.name == 'Mưa vệ tinh') > -1 &&
                                globeRainLayer.enabled
                            "
                        >
                            <b-dropdown
                                no-caret
                                dropleft
                                variant="link"
                                toggle-class="bg-transparent border-none text-left shadow-none text-decoration-none"
                                menu-class="bg-white border border-gray-500"
                            >
                                <template slot="button-content">
                                    <i
                                        :class="`fa fa-${globeRainLayer.symbol.icon} fa-lg mr-1 ${globeRainLayer.symbol.color}`"
                                    />
                                    <span class="text-dark font-weight-bold">{{
                                        globeRainLayer.name
                                    }}</span></template
                                >
                                <v-select
                                    v-model="selectedRainTime"
                                    :options="listRainData"
                                    label="time"
                                    placeholder="Chọn thời gian"
                                    :clearable="false"
                                    :closeOnSelect="false"
                                    :searchable="false"
                                >
                                    <template v-slot:option="option">
                                        {{ option.time | formatDateTime }}
                                    </template>
                                    <template v-slot:selected-option="{ time }">
                                        <span style="font-size: 12px">
                                            {{ time | formatDateTime }}
                                        </span>
                                    </template>
                                    <template v-slot:no-options="{ search, searching, loading }">
                                        Không có dữ liệu
                                    </template>
                                </v-select>
                            </b-dropdown>
                        </div>
                        <div
                            v-if="
                                listLayers.findIndex((item) => item.name == 'Mưa dự báo') > -1 &&
                                foreCastRainLayer.enabled
                            "
                        >
                            <b-dropdown
                                no-caret
                                dropleft
                                variant="link"
                                toggle-class="bg-transparent border-none text-left shadow-none text-decoration-none"
                                menu-class="bg-white border border-gray-500"
                            >
                                <template slot="button-content">
                                    <i
                                        :class="`fa fa-${foreCastRainLayer.symbol.icon} fa-lg mr-1 ${foreCastRainLayer.symbol.color}`"
                                    />
                                    <span class="text-dark font-weight-bold">{{
                                        foreCastRainLayer.name
                                    }}</span></template
                                >
                                <v-select
                                    v-model="selectedForecastRainTime"
                                    :options="listRainForecastData"
                                    label="time"
                                    placeholder="Chọn thời gian"
                                    :clearable="false"
                                    :closeOnSelect="false"
                                    :searchable="false"
                                >
                                    <template v-slot:option="option">
                                        {{ option.time | formatDateTime }}
                                    </template>
                                    <template v-slot:selected-option="{ time }">
                                        <span style="font-size: 12px">
                                            {{ time | formatDateTime }}
                                        </span>
                                    </template>
                                    <template v-slot:no-options="{ search, searching, loading }">
                                        Không có dữ liệu
                                    </template>
                                </v-select>
                            </b-dropdown>
                        </div>

                        <div
                            v-if="
                                listLayers.findIndex((item) => item.name == 'Mực nước thực đo') >
                                    -1 && waterMeasureLayer.enabled
                            "
                        >
                            <button
                                class="
                                    btn btn-link
                                    bg-transparent
                                    border-none
                                    text-left
                                    shadow-none
                                    text-decoration-none
                                    dropdown-toggle-no-caret
                                "
                                @click="setRealWaterMeasured"
                            >
                                <i
                                    :class="`fa fa-${waterMeasureLayer.symbol.icon} mr-2 ${waterMeasureLayer.symbol.color}`"
                                ></i
                                ><span class="text-dark font-weight-bold">{{
                                    waterMeasureLayer.name
                                }}</span>
                            </button>
                        </div>

                        <div
                            v-if="
                                listLayers.findIndex((item) => item.name == 'Ngập lụt') > -1 &&
                                floodLayer.enabled
                            "
                        >
                            <b-dropdown
                                no-caret
                                dropleft
                                variant="link"
                                toggle-class="bg-transparent border-none text-left shadow-none text-decoration-none"
                                menu-class="bg-white border border-gray-500"
                            >
                                <template slot="button-content">
                                    <i
                                        :class="`fa fa-${floodLayer.symbol.icon} fa-lg mr-1 ${floodLayer.symbol.color}`"
                                    />
                                    <span class="text-dark font-weight-bold">{{
                                        floodLayer.name
                                    }}</span></template
                                >
                                <v-select
                                    v-model="selectedThunderTime"
                                    :options="listThunderData"
                                    label="time"
                                    placeholder="Chọn thời gian"
                                    :clearable="false"
                                    :closeOnSelect="false"
                                    :searchable="false"
                                >
                                    <template v-slot:option="option">
                                        {{ option.time | formatDateTime }}
                                    </template>
                                    <template v-slot:selected-option="{ time }">
                                        <span style="font-size: 12px">
                                            {{ time | formatDateTime }}
                                        </span>
                                    </template>
                                    <template v-slot:no-options="{ search, searching, loading }">
                                        Không có dữ liệu
                                    </template>
                                </v-select>
                            </b-dropdown>
                        </div>
                    </div>
                </l-control>
                <l-control position="topright" v-show="!showMenu">
                    <div class="leaflet-bar">
                        <a
                            @click="
                                showMenu = true;
                                clickShowMenu = true;
                            "
                            title="Menu"
                            ><i class="fa fa-bars fa-lg"
                        /></a>
                    </div>
                </l-control>
                <l-control position="topright">
                    <div class="leaflet-bar">
                        <a @click="refreshMapView" title="Xem toàn cảnh"
                            ><i class="fa fa-home fa-lg"
                        /></a>
                    </div>
                </l-control>
                <l-control position="topright">
                    <div class="leaflet-bar">
                        <a @click="refreshMap" title="Làm mới bản đồ"
                            ><i class="fa fa-refresh fa-lg"
                        /></a>
                    </div>
                </l-control>

                <!-- List Station -->
                <div v-for="item in listStationDisplay">
                    <l-marker
                        :lat-lng="[parseFloat(item.long), parseFloat(item.lat)]"
                        @click="openPopupDetail(item)"
                    >
                        <l-tooltip>{{ toolTipValue(item) }}</l-tooltip>
                        <l-icon
                            :class-name="`station-bg ${getStationColor(
                                mapCurrentWater[item.code] ? mapCurrentWater[item.code] : 0,
                                item
                            )}`"
                        >
                            <div>
                                <span>{{
                                    mapCurrentWater[item.code] ? mapCurrentWater[item.code] : 0
                                }}</span>
                            </div>
                        </l-icon>
                    </l-marker>
                </div>

                <l-geo-json
                    v-if="geoJsonData"
                    :geojson="geoJsonData"
                    ref="geoJson"
                    :options="options"
                    :options-style="styleFunction"
                />
            </l-map>
            <LegendInfo style="position: absolute; width: 100%; bottom: 10px; z-index: 999" />
        </div>

        <!-- Station Modal Info -->
        <b-modal
            v-model="showPopupDetail"
            :hide-header="true"
            :hide-footer="true"
            centered
            :static="true"
            :lazy="true"
            modal-class="station-modal"
        >
            <b-card
                class="detail-card"
                :header-class="getHeaderColor"
                :header-text-variant="
                    currentStation.currentWater < 3 && currentStation.currentWater >= 1
                        ? 'black'
                        : 'white'
                "
                align="center"
            >
                <template #header>
                    <h4 class="font-weight-bold">
                        {{ `${currentStation.name}` }}
                    </h4>
                    <div>
                        {{ currentStation.description }}
                    </div>
                    <div>
                        {{ `(${currentStation.long}, ${currentStation.lat})` }}
                    </div>
                </template>
                <b-row align-v="center">
                    <b-col>
                        <h3>{{ `${isRainOption ? 'Lượng mưa' : 'Mực nước'}` }}</h3>
                        <h2 class="font-weight-bold">
                            {{ `${currentStation.currentWater} ${isRainOption ? 'mm/h' : 'm'}` }}
                        </h2>
                    </b-col>
                    <b-col>
                        <i :class="['fa fa-tint fa-5x', getIconColor]" />
                    </b-col>
                    <b-col>
                        <h3>
                            {{ waterStatus }}
                        </h3>
                    </b-col>
                </b-row>
                <div class="mt-2">Cập nhật ngày {{ $moment() | formatDateTime }}</div>
            </b-card>
            <b-card class="history-card text-center">
                <BarChartHistory v-if="isRainOption" :historyData="historyData" />
                <LineChartHistory v-else :historyData="historyData" />
            </b-card>
        </b-modal>

        <!-- Modal dien tich ngap -->
        <b-modal
            v-model="showModalFlood"
            :hide-header="true"
            :hide-footer="true"
            centered
            :static="true"
            :lazy="true"
            modal-class="station-modal"
        >
            <BarChartFloodAnalyze />
            <hr />
            <BarChartFloodAnalyzeByTime />
        </b-modal>

        <!-- Modal cap nhat tuyen -->
        <b-modal
            :ok-title="$t('common.update')"
            title="Lưu thông tin tuyến"
            :cancel-title="$t('common.cancel')"
            @ok="onOk"
            no-close-on-esc
            no-close-on-backdrop
            v-model="showRouteModal"
        >
            <div>
                <span class="mr-2 font-weight-bold">Thiết lập thời gian:</span>
                <RDateTimePicker
                    :value="$moment(new Date(), 'DD/MM/YYYY HH:mm')"
                    :type="'datetime'"
                />
            </div>
            <div class="mt-2">
                <span class="font-weight-bold">Điểm khởi hành: </span>{{ waypoints[0] }}
            </div>
            <div><span class="font-weight-bold">Điểm đích: </span>{{ waypoints[1] }}</div>
        </b-modal>

        <!-- Modal upload image -->
        <b-modal title="Đăng ảnh" no-close-on-esc no-close-on-backdrop v-model="showModalPhoto">
            <b-form-group label="Mô tả">
                <b-form-textarea v-model="description" rows="3" placeholder="Nhập thông tin" />
            </b-form-group>
            <b-form-group label="Địa điểm">
                <b-form-input v-model="locationDisplay" placeholder="Nhập thông tin" />
            </b-form-group>
            <b-form-group label="Hình ảnh">
                <b-form-file
                    v-model="imageData"
                    accept="image/*"
                    :capture="true"
                    placeholder="Chưa có ảnh"
                    browse-text="Chụp ảnh"
                />
            </b-form-group>

            <template #modal-footer="{ ok, cancel }">
                <b-button variant="secondary" @click="cancel()">
                    {{ $t('common.cancel') }}
                </b-button>
                <b-button variant="primary" @click="updateLocate" :disabled="loading">
                    <b-spinner v-if="loading" small /> {{ $t('common.update') }}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import CONSTANTS from '../constants';
import API_CONFIG from '@/api-config';
import RDateTimePicker from '@/components/RDateTimePicker';
import LegendInfo from '@/components/LegendInfo';
import BarChartHistory from '@/components/BarChartHistory';
import LineChartHistory from '@/components/LineChartHistory';
import BarChartFloodAnalyze from '@/components/BarChartFloodAnalyze';
import BarChartFloodAnalyzeByTime from '@/components/BarChartFloodAnalyzeByTime';
export default {
    props: ['gestureHandling'],
    components: {
        LegendInfo,
        BarChartHistory,
        LineChartHistory,
        BarChartFloodAnalyze,
        BarChartFloodAnalyzeByTime,
        RDateTimePicker
    },
    data() {
        return {
            zoom: 11,
            center: [21.274446, 107.267796],
            selectedThunderTime: null,
            selectedRainTime: null,
            selectedForecastRainTime: null,
            listRainData: [],
            listThunderData: [],
            listRainForecastData: [],
            currentStation: {},
            showPopupDetail: false,
            showModalFlood: false,
            historyData: [],
            fetchWaterDataInterval: null,
            fetchListGeoJsonInterval: null,
            fetchBaCheWaterInterval: null,
            isShowRoute: false,
            isShowListObject: false,
            listLabelProvine: null,
            tranhLuLayer: null,
            roadLayer: null,
            tileLayerOption: 'Bản đồ số Việt Nam',
            listAnalyzeFlood: [],
            showRouteModal: false,
            waypoints: [],
            showModalPhoto: false,
            imageData: null,
            locationDisplay: null,
            description: null,
            lat: null,
            long: null,
            loading: false,
            showMenu: false,
            clickShowMenu: false
        };
    },
    async created() {
        // Get warning from Ba Che Station
        this.fetchBaCheData();
        this.getListPhotos();
        this.fetchBaCheWaterInterval = setInterval(() => {
            this.fetchBaCheData();
        }, 30000);
        this.getListLayers();
        await this.getListStation();
        this.listThunderData = await this.getListGeoJson({
            type: CONSTANTS.GEOJSON_TYPE.CURRENT_THUNDER
        });
        this.listRainData = await this.getListGeoJson({
            type: CONSTANTS.GEOJSON_TYPE.CURRENT_RAIN
        });
        this.listRainForecastData = await this.getListGeoJson({
            type: CONSTANTS.GEOJSON_TYPE.FORECAST_RAIN
        });
        this.listAnalyzeFlood = await this.getListGeoJson({
            type: CONSTANTS.GEOJSON_TYPE.CLASS_INUNDATION
        });
        this.fetchListGeoJsonInterval = setInterval(async () => {
            this.listThunderData = await this.getListGeoJson({
                type: CONSTANTS.GEOJSON_TYPE.CURRENT_THUNDER
            });
            this.listRainData = await this.getListGeoJson({
                type: CONSTANTS.GEOJSON_TYPE.CURRENT_RAIN
            });
            this.listRainForecastData = await this.getListGeoJson({
                type: CONSTANTS.GEOJSON_TYPE.FORECAST_RAIN
            });
        }, 60000);
    },
    async mounted() {
        await this.initGeoJson();
        await this.$nextTick();
        this.initMapControl();
    },
    computed: {
        ...mapState({
            listStations: (state) => state.station.items,
            geoJsonData: (state) => state.geojson.item,
            listWaterEachStation: (state) => state.station.listWater,
            layerOption: (state) => state.geojson.layerOption,
            listPhotos: (state) => state.flood.items,
            listLayers: (state) => state.layer.items
        }),
        realRainLayer() {
            return this.listLayers.find((item) => item.name == 'Mưa thực đo');
        },
        globeRainLayer() {
            return this.listLayers.find((item) => item.name == 'Mưa vệ tinh');
        },
        foreCastRainLayer() {
            return this.listLayers.find((item) => item.name == 'Mưa dự báo');
        },
        waterMeasureLayer() {
            return this.listLayers.find((item) => item.name == 'Mực nước thực đo');
        },
        floodLayer() {
            return this.listLayers.find((item) => item.name == 'Ngập lụt');
        },
        isRainGeoJsonOption() {
            return (
                this.layerOption == CONSTANTS.GEOJSON_TYPE.CURRENT_RAIN ||
                this.layerOption == CONSTANTS.GEOJSON_TYPE.FORECAST_RAIN
            );
        },
        isRainOption() {
            return this.layerOption == CONSTANTS.GEOJSON_TYPE.REAL_RAIN;
        },
        listStationDisplay() {
            if (this.layerOption == CONSTANTS.GEOJSON_TYPE.REAL_RAIN)
                return this.listStations.filter((item) => item.code.includes('F00'));
            if (this.layerOption == CONSTANTS.GEOJSON_TYPE.REAL_WATER)
                return this.listStations.filter((item) => item.code.includes('F01'));
        },
        options() {
            return {
                onEachFeature: this.onEachFeatureFunction
            };
        },
        mapCurrentWater() {
            const waterValue = {};
            this.listWaterEachStation.forEach((element) => {
                waterValue[element.stationCode] = !element.value
                    ? 0
                    : this.isRainOption
                    ? parseInt(element.value)
                    : (element.value / 100).toFixed(2);
            });
            return waterValue;
        },
        styleFunction() {
            return (feature) => {
                const properties = feature.properties.value;
                return {
                    weight: 2,
                    opacity: 1,
                    color: 'transparent',
                    fillOpacity: 0.7,
                    fillColor: this.featureStyle(properties)
                };
            };
        },
        onEachFeatureFunction() {
            return (feature, layer) => {
                let properties = feature.properties.value;
                properties = properties ? parseInt(properties) : 0;
                const tooltipTitle =
                    this.layerOption === CONSTANTS.GEOJSON_TYPE.CURRENT_RAIN ||
                    this.layerOption === CONSTANTS.GEOJSON_TYPE.FORECAST_RAIN
                        ? `Lượng mưa: ${properties} mm/h`
                        : `Mực nước: ${properties} m`;
                layer.on({
                    click: (e) => {
                        this.zoomToFeature(e);
                        if (this.layerOption === CONSTANTS.GEOJSON_TYPE.CURRENT_THUNDER)
                            this.showModalFlood = true;
                    }
                });
                layer.bindTooltip(`<div>${tooltipTitle}</div>`, {
                    permanent: false,
                    sticky: true
                });
            };
        },
        onEachFeatureRegionGeojson() {
            this.listLabelProvine = L.layerGroup().addTo(this.$refs.myMap.mapObject);
            return (feature, layer) => {
                layer.on({
                    click: this.zoomToFeature
                });
                if (feature.properties && feature.properties.NAME_3) {
                    let label = L.marker(layer.getBounds().getCenter(), {
                        icon: L.divIcon({
                            className: 'region-label',
                            html: feature.properties.NAME_3,
                            iconSize: [100, 40]
                        })
                    }).addTo(this.$refs.myMap.mapObject);
                    label.addTo(this.listLabelProvine);
                }
            };
        },
        onEachFeatureVetLuGeojson() {
            return (feature, layer) => {
                layer.bindTooltip(`<div>${feature.properties.diachi}</div>`, {
                    permanent: false,
                    sticky: true
                });
            };
        },
        onEachFeatureTranhLuGeojson() {
            return (feature, layer) => {
                layer.bindTooltip(`<div>Điểm tránh lũ tại ${feature.properties.ten}</div>`, {
                    permanent: false,
                    sticky: true
                });
            };
        },
        onEachFeatureUBNDGeojson() {
            return (feature, layer) => {
                layer.bindTooltip(`<div>${feature.properties.Comune}</div>`, {
                    permanent: false,
                    sticky: true
                });
            };
        },
        onEachFeatureRoadGeojson() {
            return (feature, layer) => {
                layer.on({
                    click: this.zoomToFeature
                });
                if (feature.properties && feature.properties.ref) {
                    layer.bindTooltip(`<div>${feature.properties.ref}</div>`, {
                        permanent: false,
                        sticky: true
                    });
                }
            };
        },
        waterStatus() {
            if (this.isRainOption)
                return this.currentStation.currentWater >= 20
                    ? 'Mưa rất to'
                    : this.currentStation.currentWater >= 10
                    ? 'Mưa to'
                    : this.currentStation.currentWater >= 5
                    ? 'Mưa vừa'
                    : this.currentStation.currentWater > 0
                    ? 'Mưa nhỏ'
                    : 'Không mưa';
            if (
                !(
                    this.currentStation.warningLevel3 ||
                    this.currentStation.warningLevel2 ||
                    this.currentStation.warningLevel1
                )
            )
                return 'Thấp';
            return this.currentStation.currentWater > this.currentStation.warningLevel3 / 100
                ? 'Cấp III'
                : this.currentStation.currentWater > this.currentStation.warningLevel2 / 100
                ? 'Cấp II'
                : this.currentStation.currentWater > this.currentStation.warningLevel1 / 100
                ? 'Cấp I'
                : 'Thấp';
        },
        getHeaderColor() {
            const value = this.currentStation.currentWater;
            if (this.layerOption == CONSTANTS.GEOJSON_TYPE.REAL_RAIN)
                return value > 30
                    ? 'rainValueGather60-card-bg'
                    : value > 15
                    ? 'rainValueGather50-card-bg'
                    : value > 10
                    ? 'rainValueGather10-card-bg'
                    : value > 5
                    ? 'rainValueGather5-card-bg'
                    : 'rainValueGather0-card-bg';
            if (
                !(
                    this.currentStation.warningLevel3 ||
                    this.currentStation.warningLevel2 ||
                    this.currentStation.warningLevel1
                )
            )
                return 'rainValueGather0-card-bg';
            return value > this.currentStation.warningLevel3 / 100
                ? 'rainValueGather60-card-bg'
                : value > this.currentStation.warningLevel2 / 100
                ? 'rainValueGather45-card-bg'
                : value > this.currentStation.warningLevel1 / 100
                ? 'rainValueGather5-card-bg'
                : 'rainValueGather0-card-bg';
        },
        getIconColor() {
            const value = this.currentStation.currentWater;
            if (this.layerOption == CONSTANTS.GEOJSON_TYPE.REAL_RAIN)
                return value > 30
                    ? 'iconWater60-color'
                    : value > 15
                    ? 'iconWater50-color'
                    : value > 10
                    ? 'iconWater10-color'
                    : value > 5
                    ? 'iconWater5-color'
                    : 'iconWater0-color';
            if (
                !(
                    this.currentStation.warningLevel3 ||
                    this.currentStation.warningLevel2 ||
                    this.currentStation.warningLevel1
                )
            )
                return 'iconWater0-color';
            return value > this.currentStation.warningLevel3 / 100
                ? 'iconWater60-color'
                : value > this.currentStation.warningLevel2 / 100
                ? 'iconWater45-color'
                : value > this.currentStation.warningLevel1 / 100
                ? 'iconWater5-color'
                : 'iconWater0-color';
        }
    },
    watch: {
        async selectedThunderTime(val) {
            if (val) {
                this.selectedRainTime = null;
                this.selectedForecastRainTime = null;
                this.tranhLuLayer.addTo(this.$refs.myMap.mapObject);
                this.roadLayer.addTo(this.$refs.myMap.mapObject);
                this.setLayerOption(CONSTANTS.GEOJSON_TYPE.CURRENT_THUNDER);
                this.downGeoJson({ id: val.path });
                this.getFloodDataAnalyze({ id: this.listAnalyzeFlood[0].path });
                clearInterval(this.fetchWaterDataInterval);
            }
        },
        selectedRainTime(val) {
            if (val) {
                this.selectedThunderTime = null;
                this.selectedForecastRainTime = null;
                this.$refs.myMap.mapObject.removeLayer(this.tranhLuLayer);
                this.$refs.myMap.mapObject.removeLayer(this.roadLayer);
                this.setLayerOption(CONSTANTS.GEOJSON_TYPE.CURRENT_RAIN);
                this.downGeoJson({ id: val.path });
                clearInterval(this.fetchWaterDataInterval);
            }
        },
        selectedForecastRainTime(val) {
            if (val) {
                this.selectedThunderTime = null;
                this.selectedRainTime = null;
                this.$refs.myMap.mapObject.removeLayer(this.tranhLuLayer);
                this.$refs.myMap.mapObject.removeLayer(this.roadLayer);
                this.setLayerOption(CONSTANTS.GEOJSON_TYPE.FORECAST_RAIN);
                this.downGeoJson({ id: val.path });
                clearInterval(this.fetchWaterDataInterval);
            }
        }
    },
    methods: {
        ...mapActions({
            getThunderData: 'station/getListStationWater',
            getListStation: 'station/getList',
            getListLayers: 'layer/getList',
            getCurrentListStationWater: 'station/getCurrentListStationWater',
            getListGeoJson: 'geojson/getList',
            getListPhotos: 'flood/getList',
            uploadImage: 'news/uploadImage',
            updateOrCreate: 'flood/updateOrCreate',
            getInfoParams: 'configuration/getInfo',
            downGeoJson: 'geojson/downGeoJson',
            getFloodDataAnalyze: 'geojson/getFloodDataAnalyze'
        }),
        ...mapMutations({
            setLayerOption: 'geojson/SET_LAYER_OPTION',
            setGeoJson: 'geojson/SET_GEOJSON'
        }),
        haveClickOutSide(e) {
            if (this.clickShowMenu) {
                this.clickShowMenu = false;
                return;
            }
            this.showMenu = false;
        },
        async initGeoJson() {
            /// Lớp nền đường phố
            const roadRes = await fetch(
                'https://raw.githubusercontent.com/StorkNguyen97/geojson_ba_che_gis/main/BacheRoad.geojson'
            );
            this.roadGeojson = await roadRes.json();

            /// Lớp nền khu vực
            const regionRes = await fetch(
                'https://raw.githubusercontent.com/StorkNguyen97/geojson_ba_che_gis/main/HanhChinh.geojson'
            );
            this.regionGeojson = await regionRes.json();

            /// Lớp nền vết lũ
            const vetLuRes = await fetch(
                'https://api.canhbaolu.bache.vn/api/geojson/2020_12_01_23_00_00_OTHER.geojson'
            );
            this.vetLuGeojson = await vetLuRes.json();

            /// Lớp nền tránh lũ
            const tranhLuRes = await fetch(
                'https://raw.githubusercontent.com/StorkNguyen97/geojson_ba_che_gis/main/Vi_tri_tranh_lu_WGS84.geojson'
            );
            this.tranhLuGeojson = await tranhLuRes.json();

            // / Lớp nền UBND xã
            const UBNDXaRes = await fetch(
                'https://raw.githubusercontent.com/StorkNguyen97/geojson_ba_che_gis/main/UBNDXa.geojson'
            );
            this.UBNDGeojson = await UBNDXaRes.json();
        },
        initMapControl() {
            const map = this.$refs.myMap.mapObject;

            // Leaflet Photo
            this.initLeafletPhoto();

            // Routing Control
            this.routingControl = L.Routing.control({
                routeWhileDragging: true,
                altLineOptions: {
                    styles: [
                        { color: 'black', opacity: 0.15, weight: 9 },
                        { color: 'white', opacity: 0.8, weight: 6 },
                        { color: 'blue', opacity: 0.5, weight: 2 }
                    ]
                },
                router: L.Routing.mapbox(CONSTANTS.MAP_BOX_API_KEY),
                geocoder: L.Control.Geocoder.nominatim()
            }).on('routesfound', (e) => {
                this.waypoints = e.waypoints.map((item) => item.name);
            });

            // Bản đồ hành chính quốc gia
            const regionMap = L.tileLayer(
                `https://maps.vnpost.vn/api/tm/{z}/{x}/{y}@2x.png?apikey=${CONSTANTS.VN_MAP_API_KEY}`,
                {
                    attribution: 'Powered by <a href="#">Bản đồ số Việt Nam</a>'
                }
            ).addTo(map);

            const hybridMutant = L.tileLayer.bing({
                bingMapsKey: 'ArA6oVbF7ebYgOJee15IlWHGPsf7CMozhAk343Oi1HhfecgOrnlTSuYuaWaukkHa',
                imagerySet: 'AerialWithLabelsOnDemand',
                culture: 'vi-VN'
            });

            const roadMutant = L.tileLayer.bing({
                bingMapsKey: 'ArA6oVbF7ebYgOJee15IlWHGPsf7CMozhAk343Oi1HhfecgOrnlTSuYuaWaukkHa',
                imagerySet: 'RoadOnDemand',
                culture: 'vi-VN'
            });

            let regionGeojson = L.geoJSON(this.regionGeojson, {
                onEachFeature: this.onEachFeatureRegionGeojson,
                style: (feature) => {
                    return {
                        weight: 2,
                        opacity: 0.5,
                        fillColor: this.getColor(feature.properties.ID_3),
                        fillOpacity: 0.7
                    };
                }
            }).addTo(map);

            this.roadLayer = L.geoJSON(this.roadGeojson, {
                style: {
                    weight: 1,
                    color: '#f3b623',
                    fillColor: '#feefc3'
                },
                onEachFeature: this.onEachFeatureRoadGeojson
            });

            let vetLuGeojson = L.geoJSON(this.vetLuGeojson, {
                pointToLayer: function (feature, latlng) {
                    return L.marker(latlng, {
                        icon: L.divIcon({
                            className: 'station-bg rainValueGather60',
                            html: `<div><span>${
                                feature.properties.caodovet_1
                                    ? parseInt(feature.properties.caodovet_1)
                                    : 0
                            }</span></div>`
                        })
                    });
                },
                onEachFeature: this.onEachFeatureVetLuGeojson
            });

            this.tranhLuLayer = L.geoJSON(this.tranhLuGeojson, {
                pointToLayer: function (feature, latlng) {
                    return L.marker(latlng, {
                        icon: L.icon({
                            iconUrl: '/img/safety.png',
                            iconSize: [17, 17]
                        })
                    });
                },
                onEachFeature: this.onEachFeatureTranhLuGeojson
            });

            L.geoJSON(this.UBNDGeojson, {
                pointToLayer: function (feature, latlng) {
                    return L.marker(latlng, {
                        icon: L.icon({
                            iconUrl: '/img/UBND.png',
                            iconSize: [23, 32]
                        })
                    });
                },
                onEachFeature: this.onEachFeatureUBNDGeojson
            }).addTo(map);

            const baseMap = {
                'Bản đồ hành chính': regionMap,
                'Bing Map vệ tinh': hybridMutant,
                'Bing Map đường phố': roadMutant
            };

            const overlayMap = {
                'Bản đồ vết lũ huyện Ba Chẽ': vetLuGeojson,
                'Bản đồ đường tránh lũ huyện Ba Chẽ': this.roadLayer,
                'Bản đồ điểm tránh lũ huyện Ba Chẽ': this.tranhLuLayer
            };

            L.control
                .layers(baseMap, overlayMap, {
                    position: 'bottomleft'
                })
                .addTo(map);

            this.setUpPrintMap();
            // On Change map tiles Event
            map.on('baselayerchange', (e) => {
                if (e.name === 'Bản đồ hành chính') map.addLayer(regionGeojson);
                else map.removeLayer(regionGeojson);
                this.tileLayerOption = e.name;
                this.setUpPrintMap();
            });
        },
        getColor(d) {
            switch (d) {
                case 8013:
                    return '#fec493';
                case 8014:
                    return '#ffc4c6';
                case 8015:
                    return '#fefd7e';
                case 8016:
                    return '#dcfdae';
                case 8017:
                    return '#d9affb';
                case 8018:
                    return '#8cf795';
                case 8019:
                    return '#d2aaab';
                case 8020:
                    return '#dcdb30';
            }
        },
        initLeafletPhoto() {
            const photos = this.listPhotos
                .filter((item) => item.lat && item.long)
                .map((item) => {
                    return {
                        lat: parseFloat(item.lat),
                        lng: parseFloat(item.long),
                        name: item.location,
                        url: `${API_CONFIG.URL_GET_FILE}${item.image}`,
                        thumbnail: `${API_CONFIG.URL_GET_FILE}${item.image}`
                    };
                });

            this.photoLayer = L.photo.cluster().on('click', (evt) => {
                let photo = evt.layer.photo;
                let template = '<img src="{url}" class="photo-img" /><p>{name}</p>';
                evt.layer
                    .bindPopup(L.Util.template(template, photo), {
                        minWidth: 200
                    })
                    .openPopup();
            });

            this.photoLayer.add(photos).addTo(this.$refs.myMap.mapObject);
        },
        setUpPrintMap() {
            // BrowserPrint registerLayer
            if (this.tileLayerOption != 'Bản đồ số Việt Nam') {
                let typeMap = this.tileLayerOption === 'Google Map vệ tinh' ? 'hybrid' : 'roadmap';
                L.Control.BrowserPrint.Utils.registerLayer(
                    L.GridLayer.GoogleMutant,
                    'L.GridLayer.GoogleMutant',
                    (layer, utils) => {
                        return L.gridLayer.googleMutant({
                            maxZoom: 24,
                            type: typeMap,
                            attribution:
                                '&copy; <a target="_blank" href="https://www.google.com/permissions/geoguidelines/">Google Map</a> contributors'
                        });
                    }
                );
            }

            L.control
                .browserPrint({
                    documentTitle: 'Cảnh báo lũ',
                    printModes: [
                        L.control.browserPrint.mode(
                            L.Control.BrowserPrint.Mode.Landscape,
                            null,
                            null,
                            null,
                            true
                        )
                    ],
                    manualMode: false
                })
                .addTo(this.$refs.myMap.mapObject);
        },
        async fetchBaCheData() {
            const response = await this.getCurrentListStationWater({
                date: this.$moment().format('DD/MM/YYYY'),
                type: CONSTANTS.GEOJSON_TYPE.CURRENT_THUNDER,
                hour: this.$moment().format('HH'),
                stationCode: 'F01024'
            });
            let waterData = response[0] ? (response[0].value / 100).toFixed(2) : 0;
            if (waterData > 50)
                this.$toaster.error(
                    `Cảnh báo lũ cấp độ 2 tại vị trí đối diện trung tâm y tế Huyện Ba Chẽ, toạ độ [21.2730, 107.2896]`
                );
        },
        setWaterForEachStation(type) {
            if (this.fetchWaterDataInterval) clearInterval(this.fetchWaterDataInterval);
            this.getThunderData({
                date: this.$moment().format('DD/MM/YYYY'),
                type: type,
                hour: this.$moment().format('HH')
            });
            this.fetchWaterDataInterval = setInterval(() => {
                this.getThunderData({
                    date: this.$moment().format('DD/MM/YYYY'),
                    type: type,
                    hour: this.$moment().format('HH')
                });
            }, 60000);
        },
        async openPopupDetail(data) {
            let type = null;
            if (this.isRainOption) type = CONSTANTS.GEOJSON_TYPE.CURRENT_RAIN;
            else type = CONSTANTS.GEOJSON_TYPE.CURRENT_HIGH;

            const response = await this.getCurrentListStationWater({
                date: this.$moment().format('DD/MM/YYYY'),
                type: type,
                hour: this.$moment().format('HH'),
                stationCode: data.code
            });
            this.currentStation = {
                ...data,
                currentWater: !response.length
                    ? 0
                    : response[0].value && this.isRainOption
                    ? parseInt(response[0].value)
                    : (response[0].value / 100).toFixed(2)
            };
            let todayData = await this.getCurrentListStationWater({
                date: this.$moment().format('DD/MM/YYYY'),
                type: type,
                hour: this.$moment().format('HH'),
                stationCode: data.code,
                history: true
            });
            let previousDayData = await this.getCurrentListStationWater({
                date: this.$moment().subtract(1, 'days').format('DD/MM/YYYY'),
                type: type,
                stationCode: data.code,
                history: true
            });
            this.historyData = previousDayData
                .filter((item) => item.hour >= this.$moment().format('HH'))
                .concat(todayData);
            let configParams = {
                warningLevel3: data.warningLevel3 / 100,
                warningLevel2: data.warningLevel2 / 100,
                warningLevel1: data.warningLevel1 / 100
            };
            this.historyData.forEach((item) => (item.waterLevel = configParams));
            this.showPopupDetail = true;
        },
        featureStyle(feature) {
            if (this.isRainGeoJsonOption) {
                return feature > 60
                    ? '#e65100'
                    : feature > 50
                    ? '#f57c00'
                    : feature > 45
                    ? '#ffb300'
                    : feature > 40
                    ? '#ffd54f'
                    : feature > 30
                    ? '#ffee58'
                    : feature > 20
                    ? '#7cb342'
                    : feature > 15
                    ? '#aed581'
                    : feature > 10
                    ? '#1976d2'
                    : feature > 5
                    ? '#42a5f5'
                    : feature > 0
                    ? '#90caf9'
                    : '#B3DCFD';
            }
            return feature > 4
                ? '#1a237e'
                : feature > 3.5
                ? '#283593'
                : feature > 3
                ? '#303f9f'
                : feature > 2.5
                ? '#3949ab'
                : feature > 2
                ? '#3f51b5'
                : feature > 1.5
                ? '#5c6bc0'
                : feature > 1
                ? '#7986cb'
                : feature > 0.5
                ? '#9fa8da'
                : feature > 0
                ? '#c5cae9'
                : '#D2D5EB';
        },
        zoomToFeature(e) {
            this.$refs.myMap.mapObject.fitBounds(e.target.getBounds());
        },
        refreshMapView() {
            this.$refs.myMap.mapObject.setView(this.center, this.zoom);
        },
        fitBoundStation(item) {
            let marker = L.marker([item.long, item.lat]);
            let group = new L.featureGroup([marker]);
            this.$refs.myMap.mapObject.fitBounds(group.getBounds(), { maxZoom: 15 });
        },
        getStationColor(value, item) {
            if (this.layerOption == CONSTANTS.GEOJSON_TYPE.REAL_RAIN)
                return value > 30
                    ? 'rainValueGather60'
                    : value > 15
                    ? 'rainValueGather50'
                    : value > 5
                    ? 'rainValueGather10'
                    : value > 0
                    ? 'rainValueGather5'
                    : 'rainValueGather0';
            if (!(item.warningLevel3 || item.warningLevel2 || item.warningLevel1))
                return 'rainValueGather0';
            return value > item.warningLevel3 / 100
                ? 'rainValueGather60'
                : value > item.warningLevel2 / 100
                ? 'rainValueGather45'
                : value > item.warningLevel1 / 100
                ? 'rainValueGather5'
                : 'rainValueGather0';
        },
        toolTipValue(item) {
            if (this.isRainOption)
                return `${item.name} - Lượng mưa ${
                    this.mapCurrentWater[item.code] ? this.mapCurrentWater[item.code] : 0
                } mm/h`;
            return `${item.name} - Mực nước ${
                this.mapCurrentWater[item.code] ? this.mapCurrentWater[item.code] : 0
            } m`;
        },
        setRealRainMeasured() {
            this.clearGeoJsonData();
            this.$refs.myMap.mapObject.removeLayer(this.tranhLuLayer);
            this.$refs.myMap.mapObject.removeLayer(this.roadLayer);
            this.setLayerOption(CONSTANTS.GEOJSON_TYPE.REAL_RAIN);
            this.setWaterForEachStation(CONSTANTS.GEOJSON_TYPE.CURRENT_RAIN);
        },
        setRealWaterMeasured() {
            this.clearGeoJsonData();
            this.$refs.myMap.mapObject.removeLayer(this.tranhLuLayer);
            this.$refs.myMap.mapObject.removeLayer(this.roadLayer);
            this.setLayerOption(CONSTANTS.GEOJSON_TYPE.REAL_WATER);
            this.setWaterForEachStation(CONSTANTS.GEOJSON_TYPE.CURRENT_THUNDER);
        },
        clearGeoJsonData() {
            this.selectedThunderTime = null;
            this.selectedRainTime = null;
            this.selectedForecastRainTime = null;
            this.setGeoJson(null);
        },
        showRoutingControl() {
            this.isShowRoute = true;
            this.$refs.myMap.mapObject.addControl(this.routingControl);
        },
        hideRoutingControl() {
            this.isShowRoute = false;
            this.$refs.myMap.mapObject.removeControl(this.routingControl);
        },
        zoomUpdated(zoom) {
            if (zoom < 11) this.$refs.myMap.mapObject.removeLayer(this.listLabelProvine);
            else this.$refs.myMap.mapObject.addLayer(this.listLabelProvine);
        },
        onOk() {
            this.$toaster.success('Lưu dữ liệu thành công');
            this.showRouteModal = false;
            this.hideRoutingControl();
        },
        async updateLocate(modal) {
            modal.preventDefault();
            if (!this.locationDisplay || !this.imageData) {
                this.$toaster.error('Vui lòng nhập đầy đủ thông tin');
                return;
            }
            const formData = new FormData();
            formData.append('file', this.imageData);
            this.loading = true;
            const res = await this.uploadImage(formData);
            try {
                await this.updateOrCreate({
                    desc: this.description,
                    location: this.locationDisplay,
                    image: res.url,
                    lat: this.lat.toString(),
                    long: this.long.toString()
                });
                this.description = null;
                this.locationDisplay = null;
                this.imageData = null;
                this.showModalPhoto = false;
                this.$refs.myMap.mapObject.removeLayer(this.photoLayer);
                this.initLeafletPhoto();
                this.$toaster.success('Cập nhật thành công');
            } catch (error) {
                this.$toaster.error(error);
            }
            this.loading = false;
        },
        refreshMap() {
            this.$refs.myMap.mapObject.eachLayer((layer) => {
                if (
                    layer instanceof L.Circle ||
                    layer instanceof L.Rectangle ||
                    layer instanceof L.Path ||
                    layer instanceof L.Polygon
                ) {
                    this.$refs.myMap.mapObject.removeLayer(layer);
                }
            });
            this.refreshMapView();
        }
    },
    beforeDestroy() {
        if (this.fetchWaterDataInterval) {
            clearInterval(this.fetchWaterDataInterval);
        }
        if (this.fetchBaCheWaterInterval) {
            clearInterval(this.fetchBaCheWaterInterval);
        }
        clearInterval(this.fetchListGeoJsonInterval);
        this.setGeoJson(null);
    }
};
</script>
<style lang="scss">
.leaflet-popup-content {
    text-align: center !important;
}
.leaflet-marker-photo b {
    height: 16px !important;
    min-width: 16px !important;
}
.leaflet-control-browser-print {
    display: none !important;
}

.leaflet-draw-actions a {
    color: white !important;
}

.station-bg {
    margin-left: -20px !important;
    margin-top: -20px !important;
    width: 40px !important;
    height: 40px !important;
    z-index: 302 !important;
    background-clip: padding-box;
    border-radius: 20px;

    div {
        width: 30px;
        height: 30px;
        margin-left: 5px;
        margin-top: 5px;
        text-align: center;
        border-radius: 15px;
        font: 12px 'Helvetica Neue', Arial, Helvetica, sans-serif;
    }
    span {
        line-height: 30px;
    }
}
.geojson-type {
    color: black;
    margin-right: 0px !important;
    background: rgba(255, 255, 255, 0.8);
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);

    .nav-link {
        padding: 0.5rem 0.85rem !important;
        color: black;
    }

    button {
        padding: 0.45rem !important;
    }
}

.leaflet-control-search {
    .search-input {
        min-width: 150px;
    }
}
.station-modal {
    .modal-content {
        border-radius: 10px;

        .modal-body {
            padding: 0.5rem;
        }
    }
}

.photo-img {
    max-width: 100%;
    height: auto;
}

@media screen and (max-width: 500px) {
    .station-modal {
        .modal-dialog {
            margin: 1.75rem;
        }
    }
    .btn-label {
        display: none;
    }
    .photo-img {
        max-width: 30%;
        height: auto;
    }
}

.detail-card {
    border-radius: 10px;
    .card-header {
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }
}

.history-card {
    border-radius: 10px;
    margin-bottom: 0;
    .card-header {
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }
}

.region-label {
    font-size: 14px;
    z-index: 400 !important;
    height: auto !important;
    width: 90px !important;
}
</style>